import Style from "./Upload.module.scss";
import React, { useEffect, useRef, useState } from "react";

import { storage } from "../../firebase";

import {
	ref,
	// uploadBytesResumable,
	getDownloadURL,
	uploadBytes,
} from "firebase/storage";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { v4 as uuidv4 } from "uuid";

import toast, { Toaster } from "react-hot-toast";
// import {
// 	query,
// 	getDocs,
// 	where,
// 	orderBy,
// 	onSnapshot,
// } from "firebase/firestore";

const Upload = ({ user }) => {
	const [src, setSrc] = useState();

	// Show and hide .wrapper div upon dropping and dropend
	const [opacity, setOpacity] = useState(0);
	const [visibile, setVisible] = useState("hidden");
	const [preview, setPreview] = useState();

	// const [files, setFiles] = useState();

	// Manage a Paste upload
	const handleOnPaste = (event) => {
		const items = (event.clipboardData || event.originalEvent.clipboardData)
			.items;

		let blob = null;
		for (let i = 0; i < items.length; i++) {
			if (items[i].type.indexOf("image") === 0) {
				blob = items[i].getAsFile();
			}
		}

		if (blob !== null) {
			setSrc(blob);

			console.log(blob);

			// const reader = new FileReader();
			// reader.onload = function (event) {
			// 	console.log(blob);
			// 	let filePasted = dataURLtoFile(event.target.result, "a.png")
			// 	setSrc(filePasted)
			// };
			// reader.readAsDataURL(blob);
		}
	};

	// Manage a click to upload

	const hiddenFileInput = useRef();

	const handleClick = () => {
		hiddenFileInput.current.click();
	};

	const handleChange = (e) => {
		const fileUploaded = e.target.files[0];
		console.log(fileUploaded);
		setSrc(fileUploaded);
		// const reader = new FileReader();
		// reader.onload = function (event) {
		// 	setSrc(event.target.result);
		// };
		// reader.readAsDataURL(fileUploaded);
	};

	const handleRemove = () => {
		setSrc(null);
	};

	// Manage drag and drop files

	let lastTarget = null;

	const dragEnter = (e) => {
		e.preventDefault();
		setOpacity(0.5);
		setVisible("");
		lastTarget = e.target;
		// const files = e.dataTransfer.files;
		// console.log(files);
	};

	const dragLeave = (e) => {
		if (e.target === lastTarget || e.target === document) {
			setOpacity(0);
			setVisible("hidden");
		}
	};

	const dragOver = (e) => {
		e.preventDefault();
	};

	const drop = (e) => {
		e.preventDefault();
		setOpacity(0);
		setVisible("hidden");

		// console.log("File(s) dropped");

		// Prevent default behavior (Prevent file from being opened)
		e.preventDefault();
		let dt = e.dataTransfer;
		let file = dt.files[0];
		// console.log(file);
		setSrc(file);
		// console.log(file)
		// uploadImageToFirebase(file);
		// const reader = new FileReader();
		// reader.onload = function (event) {
		// 	setSrc(event.target.result);
		// };
		// reader.readAsDataURL(files[0]);
	};

	// Hide and show preview and upload component
	const hideUpload = src ? Style.hide : Style.upload;
	const hideUploaded = !src ? Style.hide : Style.uploaded;

	useEffect(() => {
		window.addEventListener("paste", (e) => handleOnPaste(e));
		window.addEventListener("dragenter", (e) => dragEnter(e));

		window.addEventListener("dragleave", (e) => dragLeave(e));
		window.addEventListener("dragover", (e) => dragOver(e));
		window.addEventListener("drop", (e) => drop(e));
	}, []);

	useEffect(() => {
		if (!src) {
			setPreview(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(src);
		setPreview(objectUrl);

		// free memory when ever this component is unmounted
		return () => URL.revokeObjectURL(objectUrl);
	}, [src]);

	const uploadImageToFirebase = (file) => {
		//

		if (!file) return;
		const fileName = uuidv4();
		const currentFileName = fileName;
		const storageRef = ref(storage, `files/${fileName}`);
		// const uploadTask = uploadBytesResumable(storageRef, file);

		const uploadFile = uploadBytes(storageRef, file).then(() => {
			getDownloadURL(storageRef).then((downloadUrl) => {
				setSrc(null);
				const newImg = {
					dateAdded: Timestamp.now(),
					imgURL: downloadUrl,
					notes: "",
					tags: [],
					colors: [],
					fileName: currentFileName,
				};
				console.log(newImg);
				uploadFiletoDb(newImg);
			});
		});

		toast.promise(uploadFile, {
			loading: "Uploading...",
			success: "File uploaded successfully",
			error: "Uh oh, there was an error!, try again",
		});
	};

	const handleUpload = () => {
		uploadImageToFirebase(src);
		//add imageURls to server with user
	};

	const uploadFiletoDb = async (newPost) => {
		// TODO
		// console.log(newPost);
		// console.log(user);
		// Upload to logged in users's collection with uid

		try {
			await addDoc(collection(db, `users/${user?.uid}/images`), newPost);
		} catch (error) {
			toast.error(error);
		}
	};

	const showUploadBtn = !src ? Style.hideBtn : Style.controls;

	return (
		<>
			<Toaster
				// position="top-right"
				reverseOrder={false}
				toastOptions={{
					style: {
						fontSize: "2rem",
					},
				}}
			/>
			<div
				className={Style.wrapper}
				style={{ visibility: `${visibile}`, opacity: `${opacity}` }}
			>
				DROP HERE
			</div>
			<div className={Style.container}>
				<div
					className={hideUploaded}
					// style={{backgroundImage:`url(${src})`}}
				>
					<img src={preview} alt="" />
					<div className={Style.deleteIcon} onClick={handleRemove}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="#000"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
							// class="ai ai-Cross"
						>
							<path d="M20 20L4 4m16 0L4 20" />
						</svg>
					</div>
				</div>

				<div className={hideUpload}>
					<span className={Style.desc}>
						Copy & Paste or Drag & Drop an image anywhere on this page
					</span>
					<div className={Style.imageIcon} onClick={handleClick}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="#db1445"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
							// class="ai ai-Image"
						>
							<path d="M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6z" />
							<circle cx="8.5" cy="8.5" r="2.5" />
							<path d="M14.526 12.621L6 22h12.133A3.867 3.867 0 0 0 22 18.133V18c0-.466-.175-.645-.49-.99l-4.03-4.395a2 2 0 0 0-2.954.006z" />
						</svg>
					</div>
					<input
						type="file"
						id="upload"
						accept=".png,.jpg,.jpeg"
						style={{ display: "none" }}
						ref={hiddenFileInput}
						onChange={handleChange}
					/>
				</div>
				<div className={showUploadBtn}>
					<div className={Style.uploadBtn} onClick={handleUpload}>
						UPLOAD
					</div>
				</div>
			</div>
		</>
	);
};

export default Upload;
